import { render, staticRenderFns } from "./PackageRow.vue?vue&type=template&id=2d98e0a6&scoped=true"
import script from "./PackageRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PackageRow.vue?vue&type=style&index=0&id=2d98e0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d98e0a6",
  null
  
)

export default component.exports